import { isTalkie } from '../utils';

export const SSR_PORT = typeof window === 'undefined' ? (isTalkie ? 3000 : 3001) : 3000;
